import {
  isFtthOffer,
  isMobileOffer,
  IStaticOffer,
} from "@nju/data-access-portal-offers";
import {
  IFtthOrchestrator,
  IMultiOrderOrchestrator,
} from "@nju/data-access-portal-orchestrator";
import { IScope } from "@nju/scope";
import { SidebarMobileOfferDuoTrio } from "../SidebarOfferDuoTrio";
import { SidebarFtthOffer } from "./SidebarFtthOffer";

interface ISidebarOfferProps {
  offer: IStaticOffer | undefined;
  isReactivationProcess?: boolean;
  orchestrator: IFtthOrchestrator | IMultiOrderOrchestrator | undefined;
  isOrderSummary?: boolean;
  variant?: IScope;
}

export function SidebarOffer({
  offer,
  isReactivationProcess = false,
  orchestrator,
  isOrderSummary = false,
  variant = "portal",
}: ISidebarOfferProps) {
  if (!offer) {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }

  return (
    <>
      {isFtthOffer(offer) && orchestrator?.type === "NJU_FTTH_ONBOARDING" && (
        <div data-cy="offer-box">
          <SidebarFtthOffer
            isReactivationProcess={isReactivationProcess}
            offer={offer}
            orchestrator={orchestrator}
          />
        </div>
      )}
      {isMobileOffer(offer) &&
        orchestrator?.type === "NJU_MULTIORDER_ONBOARDING" && (
          <SidebarMobileOfferDuoTrio
            isOrderSummary={isOrderSummary}
            offer={offer}
            orchestrator={orchestrator}
            variant={variant}
          />
        )}
    </>
  );
}
